import React from 'react';
import styles from '../styles/Homeheader.module.css'; // Import the CSS Module
import header from "../img/header-bg.png"

const Homeheader = () => {
  return (
   <div id='home' className={styles.header_container}>
    <div className={styles.header_left}>
      <h1>Transforming<br /> Vision into <span>Value</span></h1>
      <p>Expert management consultancy services backed by over 35 years of proven excellence in financial services and business transformation.</p>
      <div>
        <a href="#services">Our Services →</a>
        <a href="#credentials">Learn More</a>
      </div>
    </div>
    <div className={styles.header_image_cont}>
      <img src={header} alt="headerbg" />
    </div>
   </div>
  );
};

export default Homeheader;